import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";

import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";

// import ComparePEORatesWrapper from "@components/layouts/comparepeoratesWrapper";
import CrmOffersWrapper from "@components/layouts/crmOffersWrapper";

export default function NextAutoWarrantyHome(): ReactElement {
    return (
        <CrmOffersWrapper>
            <div className={`max-w-7xl mx-auto block px-4vw lg:px-4`}>
                <div className="bg-white">
                    <ContactTop iconsFillColor="#1c75bc" />
                </div>
                <FormSection iconsFillColor="#1c75bc" />
            </div>
        </CrmOffersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
